export default "__VITE_ASSET__addc0774__"